// src/components/common/NavigationInjector.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const NavigationInjector: React.FC = () => {
  const navigate = useNavigate();
  const auth = useAuth() as any;

  useEffect(() => {
    if (auth._setNavigate) auth._setNavigate(navigate);
  }, [navigate, auth]);

  return null;
};

export default NavigationInjector;
